"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAccessibleSportsResponseDto = instanceOfAccessibleSportsResponseDto;
exports.AccessibleSportsResponseDtoFromJSON = AccessibleSportsResponseDtoFromJSON;
exports.AccessibleSportsResponseDtoFromJSONTyped = AccessibleSportsResponseDtoFromJSONTyped;
exports.AccessibleSportsResponseDtoToJSON = AccessibleSportsResponseDtoToJSON;
exports.AccessibleSportsResponseDtoToJSONTyped = AccessibleSportsResponseDtoToJSONTyped;
/**
 * Check if a given object implements the AccessibleSportsResponseDto interface.
 */
function instanceOfAccessibleSportsResponseDto(value) {
    if (!('sportCodes' in value) || value['sportCodes'] === undefined)
        return false;
    if (!('reorderSports' in value) || value['reorderSports'] === undefined)
        return false;
    return true;
}
function AccessibleSportsResponseDtoFromJSON(json) {
    return AccessibleSportsResponseDtoFromJSONTyped(json, false);
}
function AccessibleSportsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportCodes': json['sportCodes'],
        'reorderSports': json['reorderSports'],
    };
}
function AccessibleSportsResponseDtoToJSON(json) {
    return AccessibleSportsResponseDtoToJSONTyped(json, false);
}
function AccessibleSportsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportCodes': value['sportCodes'],
        'reorderSports': value['reorderSports'],
    };
}
